function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeGuarantee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 250.8 250.8",
    width: 85,
    height: 85,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00000"
    },
    d: "M228.3 43.4C193.2 33.6 159.5 19.3 128.1.8c-1.7-1-3.7-1-5.4 0C91.3 19.4 57.6 33.7 22.4 43.4c-2.3.6-3.9 2.7-3.9 5.1v53.9c0 55.4 25.5 92.1 47 113.3 23.2 22.6 50 35.2 59.8 35.2s36.7-12.5 59.8-35.2c21.5-21 47-57.8 47-113.2V48.4c.1-2.4-1.5-4.4-3.8-5zm-6.6 59c0 51.7-23.8 86-43.9 105.6-22.8 22.1-47 32.1-52.4 32.1S95.8 230.1 73 208c-20-19.6-44-53.9-44-105.6v-50c33.7-9.5 66.1-23.3 96.3-40.9C155.7 29 188 42.7 221.7 52.3v50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00000"
    },
    d: "M113.7 151.7L112 150c-2-2.1-2-5.4 0-7.4L155.6 99c2.1-2 5.4-2 7.4 0l1.7 1.7c2 2.1 2 5.4 0 7.4l-43.6 43.6c-2 2.1-5.3 2-7.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00000"
    },
    d: "M121 151.7l1.7-1.7c2-2.1 2-5.4 0-7.4L95.1 115c-2.1-2-5.4-2-7.4 0l-1.7 1.7c-2 2.1-2 5.4 0 7.4l27.6 27.6c2 2 5.3 2 7.4 0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeGuarantee);
export default __webpack_public_path__ + "static/media/we-guarantee.bafd5c8ae294e11c0029c249a14841a9.svg";
export { ForwardRef as ReactComponent };